import React from 'react';
import { Section } from '@atlaskit/side-navigation';
import { useIntl } from '@atlassian/jira-intl';
import { MenuItem } from '@atlassian/jira-navigation-apps-sidebar-common/src/common/ui/menu-item/main.tsx';
import { useNavigationAutomationLegacyEnabledResource } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/common/navigation-automation-resource/index.tsx';
import { NestingMenuItem } from '@atlassian/jira-navigation-apps-sidebar-common/src/ui/nesting-menu-item/main.tsx';
import { SERVICE_DESK_AUTOMATION_SUB_NAV, SETTINGS_IDS } from '../../constants.tsx';
import {
	getAutomationPaths,
	isAutomationSubNavSelected,
	isJiraAutomationSelected,
	isServiceDeskAutomationSelected,
} from '../../utils/automation-paths/index.tsx';
import { useLegacySpaClickHandler } from '../../utils/index.tsx';
import messages from './messages.tsx';
import type { Props } from './types.tsx';

/**
 * @deprecated This is a Nav3 component. If you do any changes here, please apply and QA them at Nav4 component as well: src/packages/navigation-apps/sidebar-nav4/project-settings
 */
export const Automation = ({
	overrides,
	shifter,
	projectKey,
	isSimplified,
	hasJiraAutomation,
}: Props) => {
	const { enabled: isLegacyAutomationEnabled } =
		useNavigationAutomationLegacyEnabledResource().data || {};

	const { formatMessage } = useIntl();
	const handleLegacySPAClick = useLegacySpaClickHandler();
	const automationPaths = getAutomationPaths({ projectKey, isSimplified });
	if (!isLegacyAutomationEnabled && !hasJiraAutomation) {
		return null;
	}

	return (
		<>
			{isLegacyAutomationEnabled ? (
				<NestingMenuItem
					id={SERVICE_DESK_AUTOMATION_SUB_NAV}
					analytics={{
						itemId: SETTINGS_IDS.AUTOMATION_SUB_NAV,
					}}
					title={formatMessage(messages.automation)}
					href={hasJiraAutomation ? automationPaths.jira : automationPaths.serviceDesk}
					overrides={overrides}
					shifter={shifter}
					selectedOn={isAutomationSubNavSelected(automationPaths)}
					onClick={
						(hasJiraAutomation && isSimplified) || __SPA__ ? undefined : handleLegacySPAClick
					}
				>
					<Section title={formatMessage(messages.automation)}>
						{hasJiraAutomation && (
							<MenuItem
								analytics={{ itemId: SETTINGS_IDS.JIRA_AUTOMATION }}
								href={automationPaths.jira}
								onClick={isSimplified ? undefined : handleLegacySPAClick}
								selectedOn={isJiraAutomationSelected(automationPaths)}
							>
								{formatMessage(messages.jiraAutomation)}
							</MenuItem>
						)}
						<MenuItem
							analytics={{ itemId: SETTINGS_IDS.AUTOMATION }}
							selectedOn={isServiceDeskAutomationSelected(automationPaths)}
							href={automationPaths.serviceDesk}
							onClick={__SPA__ ? undefined : handleLegacySPAClick}
						>
							{formatMessage(messages.legacyAutomation)}
						</MenuItem>
					</Section>
				</NestingMenuItem>
			) : (
				<MenuItem
					analytics={{ itemId: SETTINGS_IDS.JIRA_AUTOMATION }}
					href={hasJiraAutomation ? automationPaths.jira : automationPaths.serviceDesk}
					onClick={isSimplified ? undefined : handleLegacySPAClick}
					selectedOn={
						hasJiraAutomation
							? isJiraAutomationSelected(automationPaths)
							: isServiceDeskAutomationSelected(automationPaths)
					}
				>
					{formatMessage(messages.jiraAutomation)}
				</MenuItem>
			)}
		</>
	);
};
